// Full-document render of the sealy UtilityPage: PageSkeleton (the React
// document shell) wrapping the utility layout.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { UtilityPageLayout } from "../components/UtilityPageLayout";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton).
export const Template = (
    props: templates.UtilityPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <UtilityPageLayout page={props.page} />
    </PageSkeleton>
);
